import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AsdCallbackComponent } from './asd-callback/asd-callback.component';
import { AuthInterceptorService } from './auth-interceptor.service';
import { LoginRedirectService } from './login-redirect.service';
import { SsoOptionsService } from './sso-options.service';
import { AuthGuardService } from './auth-guard.service';
import { LoggedInService } from './logged-in.service';
import { SsoOptions } from './sso-options';

@NgModule({
  imports: [CommonModule, MatProgressBarModule, AsdCallbackComponent],
})
export class SsoModule {
  static forRoot(ssoOptions: SsoOptions): ModuleWithProviders<SsoModule> {
    return {
      ngModule: SsoModule,
      providers: [
        AuthGuardService,
        LoggedInService,
        AuthInterceptorService,
        SsoOptionsService,
        LoginRedirectService,
        {
          provide: 'SsoOptions',
          useValue: ssoOptions,
        },
      ],
    };
  }
}
